export default "__VITE_ASSET__DmWbsoCb__"